<script setup lang="ts">
import { UiStandardButton, UiText } from '@shopexperts/shared';

const props = defineProps<{
  schemaLabel: string;
  hasPages: boolean;
}>();

const emit = defineEmits<{
  newPage: [];
}>();
</script>

<template>
  <div class="flex min-h-0 flex-1 items-center justify-center bg-se-gray-50 p-8">
    <div class="flex max-w-md flex-col items-center gap-3 text-center">
      <UiText as="h2" variant="h5" text="No page selected" />
      <UiText
        as="p"
        variant="p-small"
        class="text-se-gray-700"
        :text="props.hasPages
          ? `Pick a page from the list to edit its content, or start a new ${props.schemaLabel} page.`
          : `This schema has no pages yet. Create the first ${props.schemaLabel} page to get started.`"
      />
      <UiStandardButton label="New page" icon="plus" variant="primary" @click="emit('newPage')" />
    </div>
  </div>
</template>
